/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Injectable } from '@angular/core';
import { ResourceInterface } from '@app/shared/models/resource.interface';
import { Observable } from 'rxjs';
import { ApiQuery } from '@app/core/http/api-query';
import { PaginatedResponse } from '@app/shared/models/paginated-response.model';
import { CommentModel } from '@app/shared/components/comments/comment.model';
import { map } from 'rxjs/operators';
import { HttpResponse } from '@app/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class CommentsService implements ResourceInterface {
  /**
   * Whether or not the comments' textarea has any value typed in
   */
  hasValue = false;

  constructor(private http: HttpClient) {}

  destroy(id: number): Observable<any> {
    return this.http.delete('v1/comments/' + id);
  }

  index(query: ApiQuery = new ApiQuery()): Observable<PaginatedResponse> {
    return this.http.get('v1/comments', query.buildGetOptions()).pipe(
      map((response: HttpResponse) => {
        response.data = response.data.map((comment: any) => {
          // Използва се за едит и подобни неща, които не са нужни на API-то
          comment['meta_front'] = {};
          comment['meta_front']['edit'] = false;

          return new CommentModel().deserialize(comment);
        });

        return new PaginatedResponse().deserialize(response);
      })
    );
  }

  show(id: number, query: ApiQuery): Observable<CommentModel> {
    return undefined;
  }

  store(comment: CommentModel): Observable<CommentModel> {
    return this.http.post('v1/comments', comment).pipe(
      map((response: HttpResponse) => {
        return new CommentModel().deserialize(response.data);
      })
    );
  }

  update(model: CommentModel): Observable<CommentModel> {
    return this.http.put('v1/comments/' + model.id, model).pipe(
      map((response: HttpResponse) => {
        return new CommentModel().deserialize(response.data);
      })
    );
  }
}
